<template>
  <div class="finance-tabs" ref="tabsRoot">
    <router-link
      ref="tab-History"
      v-if="role !== 'partner'"
      :to="{ name: 'History' }"
      class="finance-tabs__item"
      :class="{ active: isHistory }"
    >
      <span>{{ $t('header.history') }}</span>
    </router-link>
    <router-link
      ref="tab-Documents"
      :to="{ name: 'Documents' }"
      class="finance-tabs__item"
      :class="{ active: isDocuments }"
    >
      <span>{{ $t('header.documents') }}</span>
    </router-link>
    <router-link
      ref="tab-Cashback"
      :to="{ name: 'Cashback' }"
      class="finance-tabs__item"
      :class="{ active: isCashback }"
    >
      <span>{{ $t('header.cashback_and_commission') }}</span>
    </router-link>
    <i class="finance-tabs__indicator" :style="indicatorStyle"></i>
    <i class="finance-tabs__line"></i>
  </div>
</template>

<script>
export default {
  name: 'FinanceTabs',
  data() {
    return {
      indicatorLeft: 0,
      indicatorWidth: 0,
    };
  },
  computed: {
    role() {
      return this.$store.state.Auth.role;
    },
    isDocuments() {
      return this.$route.name === 'Documents';
    },
    isHistory() {
      return this.$route.name === 'History';
    },
    isCashback() {
      return this.$route.name === 'Cashback';
    },
    activeTabName() {
      if (this.isHistory) return 'History';
      if (this.isDocuments) return 'Documents';
      if (this.isCashback) return 'Cashback';
      if (this.role !== 'partner') return 'History';
      return 'Cashback';
    },
    indicatorStyle() {
      return {
        width: `${this.indicatorWidth}px`,
        transform: `translateX(${this.indicatorLeft}px)`,
      };
    },
  },
  mounted() {
    this.$nextTick(this.updateIndicator);
    window.addEventListener('resize', this.updateIndicator);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIndicator);
  },
  watch: {
    '$route.name'() {
      this.$nextTick(this.updateIndicator);
    },
    role() {
      this.$nextTick(this.updateIndicator);
    },
  },
  methods: {
    updateIndicator() {
      const tabRef = this.$refs[`tab-${this.activeTabName}`];
      const tabEl = tabRef && tabRef.$el ? tabRef.$el : tabRef;
      if (!tabEl) return;
      this.indicatorLeft = tabEl.offsetLeft;
      this.indicatorWidth = tabEl.offsetWidth;
    },
  },
};
</script>

<style scoped lang="scss">
.finance-tabs {
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  gap: 40px;
  margin-bottom: 24px;
  padding-bottom: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.finance-tabs__item {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  color: #9b9fa8;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  padding: 2px 0 16px;
  white-space: nowrap;
  position: relative;
  z-index: 1;
}

.finance-tabs__item.active {
  color: #333333;
}

.finance-tabs__indicator {
  position: absolute;
  left: 0;
  height: 3px;
  bottom: 0;
  border-radius: 5px;
  background: #395fe4;
  transition: transform 0.25s ease, width 0.25s ease;
  z-index: 1;
  pointer-events: none;
}

.finance-tabs__line {
  position: absolute;
  left: 0;
  height: 2px;
  border-radius: 5px;
  background: #e3e6ec;
  width: 100%;
  bottom: 0;
  pointer-events: none;
}
</style>
